import React, { createContext, useContext, useEffect, useState } from 'react';
import { fetchDashboard } from '../services/dashboardApi';
import { fetchBin } from '../services/enquiriesApi';

const EnquiryCountsContext = createContext({ counts: {}, setCounts: () => {} });

export function EnquiryCountsProvider({ children }) {
  const [counts, setCounts] = useState({ distributor: null, superStockist: null, distributorBin: null, superStockistBin: null });

  useEffect(() => {
    let cancelled = false;
    const refreshCounts = () => fetchDashboard().then(async dashboard => {
      if (cancelled) return;
      let distributorBin = dashboard?.stats?.distributorBin;
      let superStockistBin = dashboard?.stats?.superStockistBin;
      if (distributorBin === undefined || superStockistBin === undefined) {
        const [distributorItems, superStockistItems] = await Promise.all([
          fetchBin('distributors').catch(() => null),
          fetchBin('super-stockists').catch(() => null),
        ]);
        distributorBin = distributorItems?.length;
        superStockistBin = superStockistItems?.length;
      }
      if (cancelled) return;
      setCounts({
        distributor: dashboard?.stats?.totalDistributor || 0,
        superStockist: dashboard?.stats?.totalSuperStockist || 0,
        distributorBin: distributorBin ?? 0,
        superStockistBin: superStockistBin ?? 0,
      });
    }).catch(() => {});
    const refreshWhenVisible = () => { if (!document.hidden) refreshCounts(); };

    refreshCounts();
    const interval = window.setInterval(refreshCounts, 30000);
    window.addEventListener('focus', refreshCounts);
    document.addEventListener('visibilitychange', refreshWhenVisible);
    return () => {
      cancelled = true;
      window.clearInterval(interval);
      window.removeEventListener('focus', refreshCounts);
      document.removeEventListener('visibilitychange', refreshWhenVisible);
    };
  }, []);

  return <EnquiryCountsContext.Provider value={{ counts, setCounts }}>{children}</EnquiryCountsContext.Provider>;
}

export const useEnquiryCounts = () => useContext(EnquiryCountsContext);
